/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react';

import useMeetSanctionApproval from './UseMeetSanctionApproval';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import LocalConstants from '../../../Constants';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import Input from '@usas/ui-web/components/inputs/Input';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const MeetSanctionApproval = () => {
  const {
    location,
    Constants,
    isLoading,
    isSaving,
    hasMeetAnnouncement,
    meetSanctionState,
    meetSancReqObjState,
    onBackClicked,
    onApprovedClicked,
    onRejectClicked,
    onDownloadUploadedFile,
    formState,
    errorState,
    onFormValueChanged
  } = useMeetSanctionApproval();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={"Meet Sanction Request" + `${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}`}>
        {meetSanctionState.isObjLoaded === true &&
          <form noValidate>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-push-6">
                {hasMeetAnnouncement === true &&
                  <ActionIntraPageButton type="button" className="pull-right" onClick={onDownloadUploadedFile}>
                    Download Meet Announcement
                  </ActionIntraPageButton>
                }
              </div>
              <div className="col-xs-12 col-sm-6 col-sm-pull-6">
                <ReadOnly
                  label="LSC - Club Name/Club Code: "
                  name="lscClubNameCode"
                  value={`${meetSancReqObjState.lscCode || ''} - ${meetSancReqObjState.clubName || ''}/${meetSancReqObjState.clubCode || ''}`} />
              </div>
              <div className="col-xs-12">
                <ReadOnly
                  label="Submission Date: "
                  name="submissionDate"
                  value={formatDate(meetSancReqObjState.submissionDate)} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                {location.state?.isRevisit === true ?
                  <ReadOnly
                    label="Meet Name: "
                    name="meetName"
                    value={formState.meetName} />
                  :
                  <Input
                    label="Meet Name*"
                    value={formState.meetName}
                    error={errorState.meetName}
                    message={errorState.meetName}
                    name='meetName'
                    onChange={value => onFormValueChanged('meetName', value)} />}
              </div>
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Dates: "
                  name="meetDates"
                  value={`${formatDate(meetSancReqObjState.meetStartDate)} - ${formatDate(meetSancReqObjState.meetEndDate)}`} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Classification: "
                  name="meetClassification"
                  value={meetSancReqObjState.meetClassification} />
              </div>
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Type: "
                  name="meetType"
                  value={meetSancReqObjState.meetType} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                {location.state?.isRevisit === true ?
                  <ReadOnly
                    label="Sanction Number*"
                    name="meetSanctionNumber"
                    value={formState.meetSanctionNumber}
                  />
                  :
                  <Input
                    label="Sanction Number*"
                    value={formState.meetSanctionNumber}
                    error={errorState.meetSanctionNumber}
                    message={errorState.meetSanctionNumber}
                    name='meetSanctionNumber'
                    onChange={value => onFormValueChanged('meetSanctionNumber', value)} />}
              </div>
            </div>
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className="col-xs-12 usas-extra-top-margin">
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onApprovedClicked}>Approve</PrimaryButton>&nbsp;</Fragment>}
                <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onRejectClicked}>Reject</PrimaryButton></Fragment>}
              </div>
            </div>
          </form>
        }
      </WorkFlowNavigation>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </div>
  );
};

export default MeetSanctionApproval;